import { ref } from '@vue/composition-api'
import CustomerReferralApi from '@/api/waiter/CustomerReferral'
import { handleApiError } from '@/utils/errorHandler'

export default function useCustomerReferrals(vm) {
  const referralSales = ref([])
  const referralSalesSummary = ref(null)
  const referralSalesPagination = ref({
    page: 1, perPage: 20, totalCount: 0, totalPages: 0,
  })
  const referralTree = ref([])
  const isLoadingReferralSales = ref(false)
  const isLoadingReferralTree = ref(false)
  const referralSalesStartDate = ref(null)
  const referralSalesEndDate = ref(null)
  const referralSalesScope = ref('all')

  const fetchReferralSales = async (customerId, { page = 1, perPage = 20 } = {}) => {
    isLoadingReferralSales.value = true
    try {
      const res = await CustomerReferralApi.getReferralSales(customerId, {
        startDate: referralSalesStartDate.value,
        endDate: referralSalesEndDate.value,
        salesScope: referralSalesScope.value,
        page,
        perPage,
      })
      referralSales.value = res.data.referralSalesDetails || []
      referralSalesSummary.value = res.data.referralSalesSummary || null
      referralSalesPagination.value = res.data.pagination || {
        page: 1, perPage: 20, totalCount: 0, totalPages: 0,
      }
    } catch (error) {
      handleApiError(error, { $toast: vm.$toast })
    } finally {
      isLoadingReferralSales.value = false
    }
  }

  const fetchReferralTree = async customerId => {
    isLoadingReferralTree.value = true
    try {
      const res = await CustomerReferralApi.getReferralTree(customerId)
      referralTree.value = res.data.referralTree || []
    } catch (error) {
      handleApiError(error, { $toast: vm.$toast })
    } finally {
      isLoadingReferralTree.value = false
    }
  }

  const refreshAll = async customerId => {
    await Promise.all([
      fetchReferralTree(customerId),
      fetchReferralSales(customerId),
    ])
  }

  const createReferral = async ({ referrerId, referredId }) => {
    try {
      await CustomerReferralApi.createReferral({ referrerId, referredId })
      vm.$toast.success('紹介関係を登録しました')
      await refreshAll(referrerId)

      return true
    } catch (error) {
      handleApiError(error, { $toast: vm.$toast })

      return false
    }
  }

  const deleteReferral = async ({ referralId, referrerId }) => {
    try {
      await CustomerReferralApi.deleteReferral(referralId)
      vm.$toast.success('紹介関係を解除しました')
      await refreshAll(referrerId)

      return true
    } catch (error) {
      handleApiError(error, { $toast: vm.$toast })

      return false
    }
  }

  return {
    referralSales,
    referralSalesSummary,
    referralSalesPagination,
    referralTree,
    isLoadingReferralSales,
    isLoadingReferralTree,
    referralSalesStartDate,
    referralSalesEndDate,
    referralSalesScope,
    fetchReferralSales,
    fetchReferralTree,
    createReferral,
    deleteReferral,
  }
}
